<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-dialog v-model="deleteDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
              >Do you want to delete this product ?</span
            >
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
              >{{ storage.productname }}</span
            >
          </v-flex>
          <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              small
              depressed
              dark
              :color="appColor"
              @click="deleteProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              depressed
              small
              dark
              color="#3EA56E"
              @click="deleteDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
    <v-layout wrap py-2 v-if="storage">
      <v-flex xs12 sm12 md12 lg12>
        <v-layout wrap justify-start>
          <v-flex xs12 align-self-center text-left>
            <span
              style="font-family: poppinsbold; font-size: 16px; color: #292825"
              >{{ storage._id.name }}</span
            >
          </v-flex>
          <v-flex xs12 py-2 v-for="(item) in storage.products" :key="item._id">
            <v-layout wrap justify-start>
              <v-flex xs12 sm3 md3 lg2 xl2 pr-md-2 align-self-start>
                <v-layout wrap justify-start>
                  <v-flex align-self-start xs12 v-if="item.photos.length > 0">
                  <router-link :to="'/Seller/Product/Edit/'+item._id">
                    <v-img
                      :src="mediaURL + item.photos[0]"
                      aspect-ratio="1"
                      contain
                      height="100px"
                      class="align-start"
                    >
                    </v-img>
                  </router-link>
                  </v-flex>
                  <v-flex align-self-start xs12 v-else>
                  <router-link :to="'/Seller/Product/Edit/'+item._id">
                    <v-img
                      :src="require('./../../../assets/Images/no-image.png')"
                      aspect-ratio="1"
                      contain
                      height="100px"
                      class="align-start"
                    >
                    </v-img>
                  </router-link>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm9 lg6>
                <v-layout wrap justify-start pl-4>
                  <v-flex xs12 align-self-start text-left>
                  <router-link :to="'/Seller/Product/Edit/'+item._id">
                    <span
                      style="cursor:pointer;
                        font-family: opensanslight;
                        font-size: 16px;
                        color: #000000;
                      "
                    >
                      {{ item.name }}
                    </span>
                  </router-link>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 xl6>
                    <v-layout wrap>
                      <v-flex text-left xs12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                        >
                          Total Stock
                        </span>
                      </v-flex>
                      <v-flex text-left xs12>
                        <span
                          style="font-family: opensansbold; font-size: 20px"
                        >
                          {{ item.stockQuantity }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 xl6>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            color: #8d8d8d;
                            font-family: opensanslight;
                            font-size: 14px;
                          "
                          >Total price(INR)</span
                        >
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex text-left lg12>
                        <span
                          style="
                            font-family: opensansbold;
                            color: #3bc17a;
                            font-size: 20px;
                          "
                          >{{ item.price }}</span
                        >
                        <br />
                        <span
                          style="
                            color: red;
                            font-family: poppinsregular;
                            font-size: 14px;
                          "
                          >Today (Rs. {{ item.offerPrice }},
                          {{ item.discount }} % Off)</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 pt-2>
                    <v-layout wrap v-if="item.isColor">
                      <v-flex xs12 py-2 text-left>
                        <span class="ibmsemibold">Available colors/Stock</span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <v-layout wrap>
                          <v-flex
                            xs1
                            sm1
                            lg1
                            pa-2
                            v-for="(items) in item.colorDetails"
                            :key="items.color"
                          >
                            <v-avatar
                              :color="items.colorHex"
                              size="20"
                            ></v-avatar>
                            <br />
                            <span class="ibmbold">{{ items.stock }}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex text-left xs1 text-center hidden-md-and-down>
                <v-divider vertical></v-divider>
              </v-flex>
              <v-flex xs4 lg3>
                <v-flex xs12 py-2>
                  <span class="ibmbold cblack">Update Stock Quantity</span>
                </v-flex>
                <v-flex xs6 text-left align-self-start>
                  <v-switch
                    :disabled="
                      item.productStatus == 'pending' ||
                      item.productStatus == 'rejected'
                        ? true
                        : false
                    "
                    v-model="item.status"
                    true-value="active"
                    false-value="inactive"
                    color="#5DC57C"
                    hide-details
                    :ripple="false"
                    class="statusKey"
                    :loading="statusLoading"
                    @click="changeProductStatus(item)"
                  >
                    <template slot="label">
                      <span
                        class="text-capitalize"
                        style="
                          color: #000000;
                          font-family: opensanssemibold;
                          font-size: 16px;
                        "
                      >
                        {{ item.status }}
                      </span>
                    </template>
                  </v-switch>
                </v-flex>
                <v-flex align-self-start text-center py-12>
                  <v-btn
                    @click="updateStock(item)"
                    :color="appColor"
                    outlined
                    rounded
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <br />
                  <span class="ibmsemibold appColor"
                    >{{ item.stockQuantity }} left</span
                  >
                  <br />
                  <span v-if="item.stockQuantity<=0" style="background-color:black;color:white" class="ibmsemibold "
                    >&nbsp; OUT OF STOCK &nbsp;</span
                  >
                </v-flex>
              </v-flex>
              
            <v-flex xs12 py-2>
              <v-divider ></v-divider>
          </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog persistent v-model="stockDialog" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
              >Update Stock</span
            >
          </v-flex>
          <v-flex xs12 py-2 v-if="!editingItem.isColor">
            <v-text-field
              v-model="quantity"
              label="Stock"
              placeholder="Stock"
              outlined
              dense
            ></v-text-field>
          </v-flex>
          <v-flex xs12 py-2 v-if="editingItem.isColor">
            <v-layout wrap>
              <v-flex xs12 v-if="editingItem">
                <span
                  style="
                    color: #000000;
                    font-family: opensanssemibold;
                    font-size: 14px;
                  "
                  >{{ editingItem.name }}</span
                >
              </v-flex>
              <v-flex xs12 py-2>
                <v-divider></v-divider>
              </v-flex>
              <v-flex
                xs12
                pa-2
                v-for="(color, c) in editingItem.colorDetails"
                :key="c+5"
              >
                <v-text-field
                  v-model="color.stock"
                  label="Stock"
                  placeholder="Stock"
                  outlined
                  dense
                >
                  <template v-slot:prepend-inner>
                    <v-layout justify-center>
                      <v-flex xs12 align-self-start>
                        <v-avatar :color="color.colorHex" size="20"></v-avatar>
                      </v-flex>
                      <v-flex pt-1 pl-2 xs1>
                        <v-divider vertical></v-divider>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              small
              depressed
              dark
              :color="appColor"
              @click="editingItem.isColor?addStockColor():addStock()"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Submit
              </span>
            </v-btn>
          </v-flex>
          <!-- <v-flex xs6 pa-2>
            <v-btn
              tile
              block
              depressed
              small
              :color="appColor"
              dark
              @click="(stockDialog = false), (editingItem = [])"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Cancel
              </span>
            </v-btn>
          </v-flex> -->
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      statusLoading: false,
      deleteDialogue: false,
      colors: "#ff009688",
      name: "",
      stockDialog: false,
      editingItem: [],
      quantity: null,
    };
  },
  methods: {
    changeProductStatus(item) {
      this.statusLoading = true;

      axios({
        method: "POST",
        url: "/product/status/change/" + item._id,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          // id: item._id,
          status: item.status,
        },
      })
        .then((response) => {
          this.statusLoading = false;
          if (response.data.status) {
            this.msg = "Product Status Changed to " + item.status;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.statusLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/delete/" + this.storage._id,
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          // id: this.storage._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    updateStock(item) {
      this.stockDialog = true;
      this.editingItem = JSON.parse(JSON.stringify(item));
      this.quantity = this.editingItem.stockQuantity;
    },
    addStockColor() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/edit/"+this.editingItem._id,
        headers: {
          "token": localStorage.getItem("token"),
        },
        data: {
          isColor:true,
          colorDetails: this.editingItem.colorDetails
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    addStock() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/edit/"+this.editingItem._id,
        headers: {
          "token": localStorage.getItem("token"),
        },
        data: {
          stockQuantity: this.quantity
        }
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      day = day < 10 ? "0" + day : day;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style>
div.vertical-line {
  width: 1px; /* Line width */
  background-color: #8d8d8d; /* Line color */
  height: 100%; /* Override in-line if you want specific height. */
  float: left; /* Causes the line to float to left of content. 
        You can instead use position:absolute or display:inline-block
        if this fits better with your design */
}
.statusKey.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
</style>